export function linkTo(href) {
    return window ? (() => window.location.href = href) : (() => console.log(`Invalid link ${href}`));
}

export function shortenAddress(address) {
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
}